import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";
import {SearchComboboxSvgIcon} from "./SearchComboboxSvgIcon";

/** Search glyph of the mobile field, 20px. */
export const SearchComboboxSearchIcon = (props: ISearchComboboxIconProps) => (
    <SearchComboboxSvgIcon frameSize={20} {...props}>
        <path
            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
            stroke="currentColor"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M17.5 17.5L13.9167 13.9167" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    </SearchComboboxSvgIcon>
);
import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";
import {SearchComboboxSvgIcon} from "./SearchComboboxSvgIcon";

/** Search glyph of the mobile field, 20px. */
export const SearchComboboxSearchIcon = (props: ISearchComboboxIconProps) => (
    <SearchComboboxSvgIcon frameSize={20} {...props}>
        <path
            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
            stroke="currentColor"
            strokeWidth="1.66667"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M17.5 17.5L13.9167 13.9167" stroke="currentColor" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    </SearchComboboxSvgIcon>
);
